(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["free-demo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gp-demo-free__quiz-form').forEach((form) => {
    const recommendations = {
      '3-5|magic': ['Piko et le jardin des émotions', '/products/piko-et-le-jardin-des-emotions'],
      '3-5|explore': ['Léo et le bébé dinosaure', '/products/leo-et-le-bebe-dinosaure-3-5-ans'],
      '3-5|space': ['Nina range les huit planètes', '/products/nina-range-les-huit-planetes'],
      '6-8|magic': ['Sami et l’île des horloges', '/products/sami-et-l-ile-des-horloges'],
      '6-8|explore': ['Zoé et le mystère des empreintes fossiles', '/products/zoe-et-le-mystere-des-empreintes-fossiles-6-8-ans'],
      '6-8|space': ['Noé conduit un rover sur Mars', '/products/noe-conduit-un-rover-sur-mars'],
      '9-11|magic': ['Elia et la bibliothèque des histoires inachevées', '/products/elia-et-la-bibliotheque-des-histoires-inachevees'],
      '9-11|explore': ['Adam et l’enquête du dinosaure disparu', '/products/adam-et-l-enquete-du-dinosaure-disparu-9-11-ans'],
      '9-11|space': ['Sami construit une mission spatiale', '/products/sami-construit-une-mission-spatiale']
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const recommendation = recommendations[`${data.get('age')}|${data.get('universe')}`];
      if (!recommendation) return;

      const result = form.querySelector('.gp-demo-free__quiz-result');
      result.querySelector('[data-quiz-title]').textContent = recommendation[0];
      result.querySelector('[data-quiz-link]').href = recommendation[1];
      result.hidden = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
